module.exports = __webpack_public_path__ + "img/logo.a01d64a8.jpg";